import {put} from 'redux-saga/effects'
import {message} from 'antd'

import {SET_UNAUTHORIZED, LOGOUT} from '../actions/constants'

export function* putNotify({response, notify}) {
  const {status, statusText, error} = response
  if (status) {
    if (status === 401) {
      yield put({type: SET_UNAUTHORIZED, newAuthState: false})
      const logoutRoute = window.location.hash || '/';
      yield put({
        type: LOGOUT,
        data: {
          username: '',
          password: '',
          nextUrl: logoutRoute
        }
      })
      return
    } else {
      message.error(statusText)
      return
    }
  } else {
    if (notify && (error === 'undefined' || error === "")) {
      message.success(notify)
    }
    return response
  }
}



// WEBPACK FOOTER //
// ./src/sagas/utils.js